/* unplugin-vue-components disabled */import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Popup from './Popup.vue';
import { showToast } from 'vant';
import useDatePicker from './hook';
import { EDateType } from '@/interface';
export default /*#__PURE__*/_defineComponent({
  __name: 'PikerMonth',
  props: /*#__PURE__*/_mergeModels({
    data: {},
    active: {},
    columnsType: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /*#__PURE__*/_mergeModels(["confirm-month"], ["update:modelValue"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var _toRefs = toRefs(props),
      data = _toRefs.data,
      active = _toRefs.active,
      columnsType = _toRefs.columnsType;
    var emit = __emit;
    var _useDatePicker = useDatePicker(),
      zeroFill = _useDatePicker.zeroFill,
      visibleOptionNum = _useDatePicker.visibleOptionNum;
    var model = _useModel(__props, "modelValue");
    var currentValue = ref([]);
    var unit = computed(function () {
      if (_.eq(active.value, EDateType.month)) {
        return 'month';
      } else return 'year';
    });
    watch(model, function (newVal) {
      !newVal && setTimeout(currentValueSync);
    });
    watch(data, currentValueSync, {
      deep: true,
      immediate: true
    });
    function formatter(type, option) {
      if (_.eq(type, 'year')) {
        option.text += '年';
      }
      if (_.eq(type, 'month')) {
        option.text += '月';
      }
      return option;
    }
    function onCancel() {
      model.value = false;
    }
    function onConfirm(data) {
      model.value = false;
      emit('confirm-month', {
        option: data,
        unit: unit.value
      });
    }
    function currentValueSync() {
      var startTime = data.value.startTime.clone();
      var year = startTime.year();
      var month = startTime.month();
      var monthValue = zeroFill(_.add(month, 1));
      if (_.eq(active.value, EDateType.month)) {
        currentValue.value = [String(year), monthValue];
      } else if (_.eq(active.value, EDateType.year)) {
        currentValue.value = [String(year)];
      } else {
        showToast('日期类型错误');
      }
    }
    return function (_ctx, _cache) {
      var _component_van_date_picker = _resolveComponent("van-date-picker");
      return _openBlock(), _createBlock(Popup, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return model.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_date_picker, {
            onCancel: onCancel,
            onConfirm: onConfirm,
            "max-date": new Date(),
            formatter: formatter,
            modelValue: _unref(currentValue),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(currentValue) ? currentValue.value = $event : null;
            }),
            "columns-type": _unref(columnsType),
            "visible-option-num": _unref(visibleOptionNum)
          }, null, 8, ["max-date", "modelValue", "columns-type", "visible-option-num"])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});